import Entry from '@/models/Entry'
import User, { hasRole, Role } from '@/models/User'

export default class EntryPolicy {
    viewAny(user: User) {
        return hasRole(user, [Role.USER, Role.AUDITOR])
    }

    view(user: User, entry: Entry) {
        switch (user.role) {
            case Role.USER:
                return user.company?.id === entry.catalog.company.id
            case Role.AUDITOR:
                return entry.catalog.company.auditors?.some(auditor => auditor.id === user.auditor?.id)
            default:
                return false
        }
    }

    create(user: User) {
        return hasRole(user, Role.USER)
    }

    update(user: User, entry: Entry) {
        return hasRole(user, Role.USER) && user.company?.id === entry.catalog.company.id && !entry.catalog.submitted_at
    }

    restore(user: User, entry: Entry) {
        return hasRole(user, Role.USER) && user.company?.id === entry.catalog.company.id
    }

    delete(user: User, entry: Entry) {
        return hasRole(user, Role.USER) && user.company?.id === entry.catalog.company.id
    }

    forceDelete(user: User, entry: Entry) {
        return hasRole(user, Role.USER) && user.company?.id === entry.catalog.company.id
    }
}
